import { render, staticRenderFns } from "./wbbgtsResult.vue?vue&type=template&id=b963998a&scoped=true&"
import script from "./wbbgtsResult.vue?vue&type=script&lang=js&"
export * from "./wbbgtsResult.vue?vue&type=script&lang=js&"
import style0 from "./wbbgtsResult.vue?vue&type=style&index=0&id=b963998a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b963998a",
  null
  
)

export default component.exports